/* eslint-disable import/prefer-default-export */


export const passwordValidation = {
  validations: {
    minLength: 8,
    matchRegexp: /^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).*$/,
  },
  validationErrors: {
    minLength: 'Must be at least 8 characters long.',
    matchRegexp: 'Must contain at least one uppercase letter, one lowercase letter, and one number.', // eslint-disable-line max-len
  },
};



// WEBPACK FOOTER //
// ./app/scripts/utils/validationRules.js